import React from "react";
import { Button } from "antd";
import { ILicenseStatusButtonGroupProps, LICENSE_STATUSES } from "./interfaces";
import { LICENSE_STATUSES_LIST, LICENSE_STATUSES_VALUE_MAPPING } from "./constants";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line react/function-component-definition
export const LicenseStatusButtonGroup: React.FC<ILicenseStatusButtonGroupProps> = ({
  selectedStatus,
  onSelected,
  disabled,
}) => {
  return (
    <Button.Group>
      {LICENSE_STATUSES_LIST.map((status) => (
        <Button
          key={status}
          type={selectedStatus === status ? "primary" : "default"}
          onClick={() => onSelected(status)}
          disabled={selectedStatus !== status && disabled}
          ghost={selectedStatus === status && disabled}
          danger={status === LICENSE_STATUSES.REJECTED && selectedStatus === status}
          style={{ marginLeft: 0 }}
          title={LICENSE_STATUSES_VALUE_MAPPING[status]}
        >
          {LICENSE_STATUSES_VALUE_MAPPING[status]}
        </Button>
      ))}
    </Button.Group>
  );
};
